import { ResponseModel } from "../models/response/responseModel";

export const handleResponse = ({ response }) => {
  // console.log("---response is---", response);
  if (response.data && response.data !== "") {
    const responseModel = ResponseModel.fromJson(response.data);
    const isSuccess = responseModel.success;

    if (isSuccess) {
      return { data: responseModel.data, success: true };
    } else {
      return {
        errorTitle: `Error (${responseModel.meta.httpStatusCode}) - ${responseModel.meta.errorType}`,
        errorMessage: responseModel.meta.errorMessage,
        success: false,
      };
    }
  } else {
    return {
      errorTitle: "Error",
      errorMessage: "Unknown Error",
      success: false,
    };
  }
};

export const handleError = ({ error }) => {
  if (error.response && error.response.data && error.response.data !== "") {
    const responseModel = ResponseModel.fromJson(error.response.data);
    return {
      errorTitle: `Error (${responseModel.meta.httpStatusCode}) - ${responseModel.meta.errorType}`,
      errorMessage: responseModel.meta.errorMessage,
      success: false,
    };
  } else {
    return {
      errorTitle: "Error",
      errorMessage: "Unknown Error",
      success: false,
    };
  }
};
